import { useEffect } from 'react';

// Swap the document favicon to a custom URL (e.g. uploaded by an admin via
// Settings → Appearance). When the URL is falsy, the bundled default favicon
// is restored. The original href is captured once and reused — so toggling
// between custom and default works in both directions, including when the
// component using this hook unmounts.
export default function useDocumentFavicon(url) {
  useEffect(() => {
    const link = document.querySelector("link[rel='icon']");
    if (!link) return;
    if (!link.dataset.originalHref) {
      link.dataset.originalHref = link.getAttribute('href') || '';
    }
    const original = link.dataset.originalHref;
    link.setAttribute('href', url || original);
  }, [url]);
}
